export var getIds = id => id ? {
  container: "".concat(id, "__container"),
  input: id,
  label: "".concat(id, "__label"),
  radioWrapper: "".concat(id, "__radio-wrapper"),
  radioMark: "".concat(id, "__radio-mark"),
  articleWrapper: "".concat(id, "__article-wrapper"),
  description: "".concat(id, "__description"),
  asideWrapper: "".concat(id, "__aside-wrapper"),
  radioOptionContent: "".concat(id, "__radio-option-content"),
  content: "".concat(id, "__content")
} : undefined;
//# sourceMappingURL=getIds.js.map